import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubtopicMobile } from "../../../Pages/SubtopicMobile/ISubtopicMobile";

export const DeleteSubtopicMobileSlice = createSlice({
  name: "DeleteSubtopicMobile",
  initialState: {} as IReduxState<ISubtopicMobile>,
  reducers: {
    deleteSubtopicMobile: (state, _) => {
      state.isLoading = true;
    },
    successdeleteSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteSubtopicMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSubtopicMobile,
  failuredeleteSubtopicMobile,
  successdeleteSubtopicMobile,
  clearDeleteSubtopicMobileResponse,
} = DeleteSubtopicMobileSlice.actions;

export default DeleteSubtopicMobileSlice.reducer;
